import PropTypes from 'prop-types';
import React from 'react';

const Breadcrumbs = ({ breadcrumbs, onNavigate }) => {
  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-2 px-0 asset-breadcrumb">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          if (isLast) {
            return (
              <li key={crumb.id} className="breadcrumb-item active" aria-current="page">
                {crumb.name}
              </li>
            );
          }

          if (crumb.href) {
            return (
              <li key={crumb.id} className="breadcrumb-item">
                <a href={crumb.href}>{crumb.name}</a>
              </li>
            );
          }

          return (
            <li key={crumb.id} className="breadcrumb-item">
              <a href="#"
                 onClick={(e) => {
                   e.preventDefault();
                   onNavigate(crumb.id);
                 }}>
                {crumb.name}
              </a>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    href: PropTypes.string
  })),
  onNavigate: PropTypes.func.isRequired
};

export default Breadcrumbs;
